"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const table_input_1 = require("../nodes/table-input");
const join_1 = require("../nodes/join");
const query_helper_1 = require("./query-helper");
class TableInputHelper {
    constructor(dataset, columns, datasetRepo) {
        this.datasetRepo = datasetRepo;
        let datasetDef = datasetRepo.datasetByName[dataset];
        this.node = new table_input_1.default(datasetDef.name, columns);
    }
    add(dataset, columns, joinType) {
        let datasetDef = this.datasetRepo.datasetByName[dataset];
        let table = new table_input_1.default(datasetDef.name, columns);
        let join = new join_1.default(joinType);
        this.node.connect(join, 0);
        table.connect(join, 1);
        this.node = join;
        return this;
    }
    build() {
        return this.node;
    }
    buildHelper() {
        let node = this.build();
        return new query_helper_1.default(node, this.datasetRepo);
    }
}
exports.default = TableInputHelper;
